/**
 * @name Algolia.isUnexpiredSearchKey
 * @description Whether a secured search key from a cookie can still be used.
 *
 * The key cookies are meant to expire before the keys they hold, but a browser with a wrong clock or
 * a restored cookie jar can keep one past its key's expiry, and every search then fails. A secured
 * key is `base64(hmac + urlEncodedRestrictions)`, with `validUntil` in unix seconds among the
 * restrictions, so the expiry can be read from the key itself. The Rails key endpoints only ever
 * hand out keys with a `validUntil`, so a key without one is unreadable rather than unexpiring.
 */
export const isUnexpiredSearchKey = (searchKey: string): boolean => {
  let decoded;

  try {
    // Only Node's atob is deprecated (in favor of Buffer, which isn't in the browser bundle)
    decoded = atob(searchKey);
  } catch {
    return false;
  }

  const match = /validUntil=(\d+)/.exec(decoded);

  return match ? Number(match[1]) * 1000 > Date.now() : false;
};
